import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../blue-library/elements/button";
import { getGaProductName } from "../../../qnb/gtmConverter";
import { GtmManagerContext } from "../../../shared/context/gtm-manager";
import { fetchLoginState } from "../../../store/qnbProductSlice";
import { fetchWishList, fetchWishListPopup } from "../../../store/siteSlice";
import { getWishList } from "../../api/wishList";
var BookmarkBtn = function BookmarkBtn(_ref) {
    var productName = _ref.productName, code = _ref.code, size = _ref.size, btnStyle = _ref.btnStyle, iconStyle = _ref.iconStyle, onDelete = _ref.onDelete;
    var gtm = React.useContext(GtmManagerContext);
    var _useTranslation = useTranslation(), t = _useTranslation.t;
    var dispatch = useDispatch();
    var serverState = useSelector(function (state) { return state.qnbProduct; });
    var _useSelector = useSelector(function (state) { return state.site; }), wishList = _useSelector.wishList;
    var buttonRef = useRef(null);
    var isBookmark;
    if (wishList.list !== undefined) {
        isBookmark = wishList.list.find(function (e) { return e === code; });
    }
    var isLogin = serverState.loginState.userLoggedIn;
    var handleBookmarkClick = /*#__PURE__*/ function () { var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() { var resAddBookmark, resDeleteBookmark; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
        switch (_context2.prev = _context2.next) {
            case 0:
                if (isLogin) {
                    _context2.next = 4;
                    break;
                }
                dispatch({ type: "ui/setDialogOpen", payload: { status: true, page: "login", onDialogClose: function onDialogClose() { setTimeout(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { var loginState, _buttonRef$current; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return dispatch(fetchLoginState(""));
                                case 2:
                                    loginState = _context.sent;
                                    if (loginState.payload.userLoggedIn) {
                                        (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.click();
                                    }
                                case 4:
                                case "end": return _context.stop();
                            }
                        } }, _callee); })), 500); } } });
                _context2.next = 19;
                break;
            case 4:
                if (isBookmark) {
                    _context2.next = 11;
                    break;
                }
                _context2.next = 7;
                return getWishList({ type: "add", productCode: code });
            case 7:
                resAddBookmark = _context2.sent;
                if (resAddBookmark.result) {
                    dispatch(fetchWishList());
                    dispatch(fetchWishListPopup({ message: t("bookmarkProductMsg"), isShowing: true }));
                    setTimeout(function () { dispatch(fetchWishListPopup({ message: "", isShowing: false })); }, 3000);
                }
                _context2.next = 19;
                break;
            case 11:
                if (!onDelete) {
                    _context2.next = 15;
                    break;
                }
                onDelete();
                _context2.next = 19;
                break;
            case 15:
                _context2.next = 17;
                return getWishList({ type: "delete", productCode: code });
            case 17:
                resDeleteBookmark = _context2.sent;
                if (resDeleteBookmark.result) {
                    dispatch(fetchWishList());
                }
            case 19:
            case "end": return _context2.stop();
        }
    } }, _callee2); })); return function handleBookmarkClick() { return _ref2.apply(this, arguments); }; }();
    var updateWishList = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3() {
            var resAddBookmark;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!isLogin) {
                                _context3.next = 5;
                                break;
                            }
                            _context3.next = 3;
                            return getWishList({ type: "view", productCode: "" });
                        case 3:
                            resAddBookmark = _context3.sent;
                            if (resAddBookmark.result) {
                                if (resAddBookmark.data.list.indexOf(code) > -1) {
                                    dispatch(fetchWishList()); // setIsBookmark(true);
                                }
                            }
                        case 5:
                        case "end": return _context3.stop();
                    }
                }
            }, _callee3);
        }));
        return function updateWishList() { return _ref4.apply(this, arguments); };
    }();
    useEffect(function () { updateWishList(); }, [isLogin]);
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Button, { ref: buttonRef, text: "", type: "button", size: size, color: "white", btnStyle: btnStyle !== null && btnStyle !== void 0 ? btnStyle : "filled", icon: isBookmark ? "i-bookmark-off" : "i-bookmark-on", iconStyle: iconStyle !== null && iconStyle !== void 0 ? iconStyle : "text-corporate-1", onClick: function onClick() { gtm.push({ event: "trackEventNoEcommerce", "eventDetails.category": "bookmark", "eventDetails.action": "clicked", "eventDetails.label": getGaProductName(code) }); handleBookmarkClick(); } }));
};
export default BookmarkBtn;
